module.exports = __webpack_public_path__ + "static/gallery4-757ea4111ec8d22e15383f94f5337dc6.jpg";